(function() {
    'use strict';

    var conferencesApp = angular.module('conferencesApp'); 
    conferencesApp.constant('WORLDSKILLS_API_CONFERENCES', 'https://api.worldskills.org/conferences');
    conferencesApp.constant('WORLDSKILLS_CLIENT_ID', '4748493cecc1');
    conferencesApp.constant('WORLDSKILLS_API_AUTH', 'https://api.worldskills.org/auth');
    conferencesApp.constant('WORLDSKILLS_API_PEOPLE', 'https://api.worldskills.org/people');
    conferencesApp.constant('WORLDSKILLS_API_ORGANIZATIONS', 'https://api.worldskills.org/org');
    conferencesApp.constant('WORLDSKILLS_API_IMAGES', 'https://api.worldskills.org/images');
    conferencesApp.constant('WORLDSKILLS_API_RESOURCES', 'https://api.worldskills.org/resources');
    conferencesApp.constant('WORLDSKILLS_AUTHORIZE_URL', 'https://auth.worldskills.org/oauth/authorize');
    conferencesApp.constant('WORLDSKILLS_REGISTRATION_URL', 'https://auth.worldskills.org/registration/guests');
    conferencesApp.constant('LOAD_CHILD_ENTITY_ROLES', true);
    conferencesApp.constant('FILTER_AUTH_ROLES', [2500, 1000]); // Conferences, Resources
    conferencesApp.constant('ENVIRONMENT_WARNING', false);

})();
